/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { GetCollaborationToolItemDto } from './GetCollaborationToolItemDto';
import type { UserDto } from './UserDto';

export type IncidentDetailDto = {
    collaborationToolItems: Array<GetCollaborationToolItemDto>;
    createdBy?: string;
    createdDate?: number;
    criticality: number;
    id: string;
    isMutedIndefinitely: boolean;
    issueNo: number;
    lastModifiedDate?: number;
    lastOccurredDate: number;
    modifiedBy?: string;
    mutedUntil?: number;
    name: string;
    numberOfFailures: number;
    owners: Array<UserDto>;
    qualification?: IncidentDetailDto.qualification;
    status: IncidentDetailDto.status;
};

export namespace IncidentDetailDto {

    export enum qualification {
        FIXED = 'FIXED',
        FALSE_POSITIVE = 'FALSE_POSITIVE',
        NO_ACTION_NEEDED = 'NO_ACTION_NEEDED',
        DUPLICATE = 'DUPLICATE',
        AUTOMATIC = 'AUTOMATIC',
    }

    export enum status {
        OPEN = 'OPEN',
        IN_PROGRESS = 'IN_PROGRESS',
        CLOSED = 'CLOSED',
    }


}
